var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 37,
    viewBox: "0 0 26 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 37,
    fill: "url(#pattern0)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_352_349",
    transform: "translate(0 0.148649) scale(0.0104167 0.00731982)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_352_349",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACg0lEQVR4nO2aW1ITURRFl6/mx3IgEmahIxGHIwUCOhdBJwEMAJ0B8RMLP5r+IFVJ0/eR3fdkr6rzedMnd6VPOncHjDHGmHocACfANfD3sa6BY2Ah7Cs8e8A34B/wsKbugTOgE/UYlj3gF+s3frV+YglF+c7zN3+oU0mnATlg89jZNI72Bf1KeVnhNQ8TX/cV8KlwLzvJDdM//UNdCfoNx5J0AXeCfqXUGEEPorVNUkPAn4y1v4t10Qg1BFxkrP1RrIsdZkH/SJnyGPpe0G9Izpgu4ETSaVA64JLnb/4F8EbSaWA6+uOFTePonv6T782vyD5wRP8ja/lYV8AXPPMNzitkOK8Q4rxCTKi8YkE/L4cZmnoQN1TtGRwmr+iAc9LezJQ3fUrZ2/84o5+jgn1k0dHPxVobv1qXlJMQIq84Z3ubP9TXQr3fZfQwi7wi9bCtxDgqMYNnJSDlOPqQPr/dNqUy45y84rbA9Z+QIuBj6Sa2fO2cvCJnbTFybuHcKjECms8rVJs/VAmazisiCGg6r4ggABrOK6IIGJDmFS8S1tTYhCmk9DxbavwtxUzAAsRYgJhdENBaXjFKK09BreYVo7QgoOW8YpQWBLScV4wydwFN5RURv4Q/01BeEVHAB+G1J+cVEY8ilsDbbTSy5trvpiyIKGDu/T0h4ghqCgsQYwFiLECMBYixADEWIMYCxFiAGAsQYwFiXiesWT3rGDt7yT27CfU/oFV8B4ixADEWIMYCxFiAGAsQYwFiLECMBYixADEWICblLGjuNHVW5TtAjAWIsQAxFiDGAsRYgBgLEGMBYixAjAWIsQAxFiDGAsRYgBgLEGMBYixAjAWIsQBjjDFGxH/VBHCYHLBbigAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.3a326f90b825ba4de48b24ddbfc92508.svg";
export { ForwardRef as ReactComponent };